import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export class Mutations {
  public static readonly NotifyError = "notifyError";
}

export default new Vuex.Store({
  state: {
    error: null
  },
  mutations: {
    notifyError(state, error) {
      state.error = error;
    }
  },
  actions: {},
  modules: {}
});
